
export function nullToString(data: string| null| undefined):string {
  if (data === null || data === undefined) {
    data = "";
  }
  return data;
}
